import { render } from "./CollectionsTable.vue?vue&type=template&id=867db5ce"
import script from "./CollectionsTable.vue?vue&type=script&lang=js"
export * from "./CollectionsTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__